import Vue from 'vue'
import Vuex from 'vuex'

import browser from './browser'
import wechat from './wechat'
import app from './app'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    browser: browser,
    wechat: wechat,
    app: app,
  },
  strict: process.env.NODE_ENV !== 'production',
})

if (module.hot) {
  module.hot.accept(['./browser', './wechat', './app'], () => {
    store.hotUpdate({
      modules: {
        browser: require('./browser'),
        wechat: require('./wechat'),
        app: require('./app'),
      },
    })
  })
}

export default store
